import React, { useContext, useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { CardContainer } from 'src/components/CardContainer';
import { getBalanceTopUpOptions, balanceTopUp } from 'src/api/api';

import Info from 'src/pages/topup/Info';
import InfoMobile from 'src/pages/topup/InfoMobile';
import { PaymentSheet } from 'src/pages/topup/PaymentSheet';

import { Elements } from '@stripe/react-stripe-js';
import { stripePromise, stripeAppearance } from 'src/api/stripe';


export default function TopUp(props) {
  const [csSession, setCSSession] = useState(null);
  const [topUpOption, setTopUpOption] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const queryParams = new URLSearchParams(window.location.search);
  const optionIndex = queryParams.get('optionIndex');

  useEffect(() => {
    const getClientSecret = async () => {
      if (!optionIndex) {
        return;
      }
      const topUpOptionsResp = await getBalanceTopUpOptions();
      if (topUpOptionsResp.error) {
        setErrorMessage(topUpOptionsResp.message);
        return
      }
      if (optionIndex > topUpOptionsResp.options.length) {
        setErrorMessage("Invalid top up option. Please retry.");
        return
      }
      const selectedOption = topUpOptionsResp.options[optionIndex];

      const topUpResp = await balanceTopUp(selectedOption.amount);
      if (topUpResp.error) {
        setErrorMessage(topUpResp.message);
        return
      }

      setTopUpOption(selectedOption);
      setCSSession(topUpResp);
    }

    getClientSecret();
  }, []);

  if (!optionIndex) {
    if (!errorMessage) {
      setErrorMessage("Invalid top up option. Please retry.");
    }
  }

  const AlertMiddle = () => {
    return (
      <CardContainer>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignSelf: 'center',
            width: { xs: "80%", sm: "300px" },
            margin: 'auto',
          }}
        >
          <Alert severity="warning">{errorMessage}</Alert>
        </Box>
      </CardContainer>
    )
  }

  if (errorMessage) {
    return <AlertMiddle />
  }

  return (
    <Grid
      container
      sx={{
        height: {
          xs: '100%',
          sm: '100dvh',
        },
        mt: {
          xs: 4,
          sm: 0,
        },
      }}
    >
      {/* Left hand side info page */}
      <Grid
        size={{ xs: 12, sm: 5, lg: 4 }}
        sx={{
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          backgroundColor: 'background.paper',
          borderRight: { sm: 'none', md: '1px solid' },
          borderColor: { sm: 'none', md: 'divider' },
          alignItems: 'start',
          pt: 16,
          px: 10,
          gap: 4,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            width: '100%',
            maxWidth: 500,
          }}
        >
          {topUpOption && <Info amount={topUpOption.amount} bonus={topUpOption.bonus} />}
        </Box>
      </Grid>

      {/* Right hand side payment page */}
      <Grid
        size={{ sm: 12, md: 7, lg: 8 }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '100%',
          width: '100%',
          backgroundColor: { xs: 'transparent', sm: 'background.default' },
          alignItems: 'start',
          pt: { xs: 10, sm: 16 },
          px: { xs: 2, sm: 10 },
          pb: { xs: 10, sm: 16 },
          gap: { xs: 4, md: 8 },
        }}
      >
        <Card sx={{ display: { xs: 'flex', md: 'none' }, width: '100%' }}>
          <CardContent
            sx={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <Typography variant="subtitle2" gutterBottom>Payment</Typography>
              <Typography variant="body1">{topUpOption ? "$" + topUpOption.amount : "loading"}</Typography>
            </div>
            {topUpOption && <InfoMobile amount={topUpOption.amount} bonus={topUpOption.bonus} />}
          </CardContent>
        </Card>

        {csSession &&
          <Elements
            stripe={stripePromise}
            options={{
              clientSecret: csSession.clientSecret,
              customerSessionClientSecret: csSession.customerSessionClientSecret,
              appearance: stripeAppearance,
            }}
          >
            <PaymentSheet amount={topUpOption.amount} currency="SGD" />
          </Elements>
        }
      </Grid>
    </Grid>
  )
}
